/**
 *  Catálogos (config/*) → /api/v1/catalogs
 *  Forma vieja: {IdArea, NombreArea, nombre, name}, {IdEquipo, NombreEquipo, …},
 *  {IdProblema, NombreProblema, …}, {IdEstado, Estado}.
 */
import api from '../apiV1';
import { fail, done, list } from './index';

const kinds = {
   area: { path: 'catalogs/areas', id: 'IdArea', name: 'NombreArea' },
   equipo: { path: 'catalogs/equipment', id: 'IdEquipo', name: 'NombreEquipo' },
   problema: { path: 'catalogs/problems', id: 'IdProblema', name: 'NombreProblema' },
};

const toLegacy = (k) => (it) => ({
   [k.id]: it.id,
   [k.name]: it.name.es,
   nombre: it.name.es,
   name: it.name.en || '',
});

async function getAll(kind) {
   const k = kinds[kind];
   const res = await api.get(k.path);
   if (!res.ok) throw new Error(res.message);
   return (res.data || []).map(toLegacy(k));
}

// Ahora mismo el portal solo captura el nombre en español; el inglés se
// conserva si ya existía (v1 lo mantiene cuando no se manda).
const body = (k, data) => {
   const es = data[k.name] || data.nombre || '';
   const b = { name: { es } };
   if (data.name) b.name.en = data.name;
   return b;
};

const crud = (kind) => {
   const k = kinds[kind];
   return {
      [`POST config/create/${kind}`]: async (data) => done(await api.post(k.path, body(k, data))),
      [`POST config/update/${kind}`]: async (data) => done(await api.put(`${k.path}/${data[k.id]}`, body(k, data))),
      [`POST config/delete/${kind}`]: async (data) => {
         const res = await api.del(`${k.path}/${data[k.id]}`);
         if (res.status === 409) {
            return { error: true, message: 'No se puede eliminar: el registro está en uso.' };
         }
         return done(res);
      },
   };
};

export default {
   'GET config/get/areas': async () => ({ areas: await getAll('area') }),
   'GET config/get/equipos': async () => ({ equipos: await getAll('equipo') }),
   'GET config/get/problemas': async () => ({ problemas: await getAll('problema') }),
   'GET config/get/estados': async () => {
      const res = await api.get('catalogs/request-statuses');
      if (!res.ok) return fail(res);
      return { estados: (res.data || []).map((s) => ({ IdEstado: s.id, Estado: s.name })) };
   },

   ...crud('area'),
   ...crud('equipo'),
   ...crud('problema'),

   'GET config/get/equipo/problemas': async (data) => {
      const res = await api.get(`catalogs/equipment/${data.IdEquipo}/problems`);
      if (!res.ok) return fail(res);
      return list(
         (res.data || []).map((p) => ({
            IdEquipoTipoProblema: p.id,
            IdEquipo: Number(data.IdEquipo),
            IdProblema: p.problemId,
            NombreProblema: p.name,
         }))
      );
   },
   'POST config/create/equipo/problema': async (data) => {
      const res = await api.post(`catalogs/equipment/${data.IdEquipo}/problems`, { problemId: Number(data.IdProblema) });
      if (res.status === 409) return { existe: 'El detalle ya está ligado a este equipo.' };
      return done(res);
   },
   'POST config/delete/equipo/problema': async (data) => {
      // v1 pide también el equipo (solo borra si la relación es suya).
      const res = await api.del(`catalogs/equipment/${data.IdEquipo}/problems/${data.IdEquipoTipoProblema}`);
      return done(res);
   },
};
